module.exports = __webpack_public_path__ + "img/piaoquan.ef4201f2.png";